export default function model(name: string, fields: Array = []) {
    // string template and not printed from type because graphql doesn't print directives
    return `model ${name} {
  id BigInt @id @default(autoincrement())
${fields.map(f => {
  return `  ${f.name} ${f.type} ${f.directives || ''}`;
}).join("\n")}
  createdAt DateTime @default(now())
  updatedAt DateTime @default(now())
}
`;
}
